import React from "react";
import { Eye, ClipboardList, MessageSquare, ArrowRightCircle } from "lucide-react";
import { TAKEAWAYS } from "../../mock";

const ICONS = { Eye, ClipboardList, MessageSquare, ArrowRightCircle };

const Takeaways = () => {
  return (
    <section className="py-28 border-t border-[#131c31]" data-testid="takeaways-section">
      <div className="max-w-7xl mx-auto px-6">
        <p className="font-mono text-[10px] tracking-[0.35em] text-[#6f7d9f] uppercase mb-6 reveal">{TAKEAWAYS.label}</p>
        <h2 className="font-heading uppercase text-white text-4xl sm:text-5xl lg:text-6xl tracking-tight mb-14 reveal" data-testid="takeaways-headline">
          {TAKEAWAYS.headline}
        </h2>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-3 reveal">
          {TAKEAWAYS.cards.map((c) => {
            const Icon = ICONS[c.icon];
            return (
              <div key={c.title} className="card-hover border border-[#1c2740] bg-[#0c1324]/60 p-7 hover:border-[#3f639f]">
                <Icon size={22} className="text-[#6b9be8] mb-6" />
                <h3 className="font-heading uppercase text-white text-lg tracking-tight mb-3">{c.title}</h3>
                <p className="text-[#8fa0c0] text-sm leading-relaxed">{c.body}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Takeaways;
